import React from 'react';

const Stepper = ({ value, onChange, className, renderValue }) => {
    return (
        <div
            className={`flex items-center border bg-primary-100 rounded-full text-center select-none btn-inverse ${className}`}
        >
            <div
                className="px-4 py-1.5 cursor-pointer rounded-l-full"
                onClick={() => onChange(value - 1)}
            >
                -
            </div>
            <div className="px-2 py-1.5 min-w-8 text-black">
                {typeof renderValue === 'function' ? renderValue(value) : value}
            </div>
            <div
                className="px-4 py-1.5 cursor-pointer rounded-r-full"
                onClick={() => onChange(value + 1)}
            >
                +
            </div>
        </div>
    );
};

export default Stepper;
